"use client";

import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { useAppTranslate } from "src/hooks/useAppTranslate";

/**
 * Offers back the photos a customer had picked, but not yet uploaded, before
 * the page reloaded. See utils/pending-picks.ts for what is kept and why.
 *
 * Counts only, never file names: customers do not recognise "IMG_1009.jpeg".
 */

export default function PendingPicksNotice({
  saved,
  busy,
  onResume,
  onDiscard,
}: {
  saved: number;
  /** Photos picked in that load; no longer shown (owner: one short question). */
  total: number;
  busy: boolean;
  onResume: () => void;
  onDiscard: () => void;
}) {
  const translate = useAppTranslate();
  return (
    <Alert
      severity="info"
      sx={{ mb: 2, alignItems: "flex-start" }}
      role="status"
    >
      <Typography variant="body2">{translate("order.pendingPicksAsk", { saved })}</Typography>
      <Box sx={{ display: "flex", gap: 1, mt: 1.5, flexWrap: "wrap" }}>
        <Button
          variant="contained"
          size="small"
          onClick={onResume}
          disabled={busy}
          startIcon={busy ? <CircularProgress size={14} color="inherit" /> : undefined}
        >
          {translate("order.pendingPicksResume")}
        </Button>
        <Button size="small" onClick={onDiscard} disabled={busy}>
          {translate("order.pendingPicksDiscard")}
        </Button>
      </Box>
    </Alert>
  );
}
